
export function phone(value) {
  return value.toString().replace(/-/g, '.');
}

export function currency(value) {
  if (value < 0) {
    return '-$' + parseFloat(value * -1).toFixed(2);
  } else {
    return '$' + parseFloat(value).toFixed(2);
  }
}

export function freeCurrency(value) {
  if (value == 0) {
    return 'FREE';
  } else if (value < 0) {
    return '-$' + parseFloat(value * -1).toFixed(2);
  } else {
    return '$' + parseFloat(value).toFixed(2);
  }
}

export function lowercase(value) {
  return '' + value.toLowerCase();
}

export function uppercase(value) {
  return '' + value.toUpperCase();
}

export default {
  phone,
  currency,
  freeCurrency,
  lowercase,
  uppercase
};
